import Inventory from '../../inventory'
import { isMobile } from '../../utils'
import { blockIcons, blockNames } from '../../assets/block-icons'
import { getMaxDurability, InventoryItemType } from '../../items'

export default class Bag {
  constructor(
    inventory: Inventory,
    options: { getCreativeItems?: () => InventoryItemType[] | null } = {}
  ) {
    this.inventory = inventory
    this.getCreativeItems = options.getCreativeItems
    if (isMobile) return

    this.bag.className = 'bag'
    this.items[0].classList.add('selected')

    for (let i = 0; i < this.items.length; i++) {
      this.bag.appendChild(this.items[i])
    }
    document.body.appendChild(this.bag)

    document.body.addEventListener('keydown', (e: KeyboardEvent) => {
      if (this.bag.classList.contains('hidden')) return
      if (isNaN(parseInt(e.key)) || e.key === '0') {
        return
      }

      for (let i = 0; i < this.items.length; i++) {
        this.items[i].classList.remove('selected')
      }

      this.current = parseInt(e.key) - 1
      this.items[this.current].classList.add('selected')
    })

    document.body.addEventListener('wheel', (e: WheelEvent) => {
      if (this.bag.classList.contains('hidden')) return
      if (!this.wheelGap) {
        this.wheelGap = true
        setTimeout(() => {
          this.wheelGap = false
        }, 100)
        if (e.deltaY > 0) {
          this.current++
          this.current > 8 && (this.current = 0)
        } else if (e.deltaY < 0) {
          this.current--
          this.current < 0 && (this.current = 8)
        }
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].classList.remove('selected')
        }
        this.items[this.current].classList.add('selected')
      }
    })
  }

  inventory: Inventory
  getCreativeItems?: () => InventoryItemType[] | null
  wheelGap = false
  current = 0

  bag = document.createElement('div')

  items = new Array(9).fill(null).map(() => {
    let item = document.createElement('div')
    item.className = 'item'
    return item
  })

  /**
   * Refresh the hotbar display to reflect current inventory state.
   */
  refresh() {
    const creativeItems = this.getCreativeItems?.() ?? null
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i]
      // clear existing children except the selection border effect
      item.innerHTML = ''

      const inventorySlot = this.inventory.getSlot(i)
      const slot = inventorySlot ??
        (creativeItems?.[i] !== undefined
          ? { type: creativeItems[i], count: 1 }
          : null)
      if (slot) {
        const icon = blockIcons[slot.type]
        if (icon) {
          const img = document.createElement('img')
          img.className = 'icon'
          img.alt = 'block'
          img.src = icon
          img.draggable = false
          item.appendChild(img)
        } else {
          // fallback: text label for blocks without icons
          const fallback = document.createElement('div')
          fallback.className = 'hotbar-fallback'
          fallback.textContent = (blockNames[slot.type] || '?')
            .charAt(0)
            .toUpperCase()
          item.appendChild(fallback)
        }

        if (slot.count > 1) {
          const badge = document.createElement('span')
          badge.className = 'hotbar-count'
          badge.textContent = String(slot.count)
          item.appendChild(badge)
        }

        const max = getMaxDurability(slot.type)
        if (max > 0 && slot.durability !== undefined && slot.durability < max) {
          const bar = document.createElement('div')
          bar.className = 'durability-bar'
          const fill = document.createElement('div')
          fill.className = 'durability-fill'
          const ratio = Math.max(0, slot.durability / max)
          fill.style.width = `${ratio * 100}%`
          const hue = Math.round(120 * ratio)
          fill.style.background = `hsl(${hue}, 90%, 50%)`
          bar.appendChild(fill)
          item.appendChild(bar)
        }
      }
    }
  }
}
